import React from 'react'

function Loader() {
  return (
    <div className='loader w-100 h-4 bg-green-600'></div>
  )
}

export default Loader;